import React from 'react';
import './LogInPage.js.css';
import '../styles/generics.css';
import logo from '../images/logo.png';
import bkg from '../images/main_background.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Button, Modal } from 'react-bootstrap';
import Connection from '../config/Connection';
import sha1 from 'crypto-js/sha1';
import AppStorage from '../config/AppStorage';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import MaskedInput from '../components/MaskedInput';


export default class LogInPage extends PageComponent {

  static PageInfo = {
    id: 1,

    path: "/",
    name: "menu.login",
    icon: "key",
    hidden: true,
  }

  constructor(props) {
    super(props);
    this.state.mode = 1;
    this.state.user = "";
    this.state.password = "";
    this.state.loading = false;
    this.state.error = null;
    this.state.isModalVisible = null;
    this.state.lgpd = null
  }

  loginUser() {
    this.setState({ loading: true, error: null });
    if (this.state.mode > 1) {
      this.getSession(this.state.user, this.state.password);
    }
    else {
      this.getSalt(this.state.user, this.state.password);
    }
  }




 
  getSession(user, pass) {
    console.log('Iniciando Login ==>',pass)

    Connection.Secure(Connection.service + "Login/" + (this.state.mode == 1 ? "User" : "Employee"),
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({ user: user, pass: pass })
      }).then((response) => {
      console.log('Response ==>',response)
      if (response.ok && response.status == 200) {
        response.json().then((data) => {
          console.log('DATA LGPD ==>',data)
          if(data.lgpd && data.lgpd.acceptStatus == 1) {
            AppStorage.SetUserCredentials(data.session, data.token);
            // global.app.forceUpdate();
            window.location.reload();
          }
          else {
            console.log('LGPD ==>',data)
            this.props.history.push('/LGPD', data)
          }
        }).catch((err) => {
          this.setError();
          console.log('ERRO CHAMADA ==>',err)
        });
      } else{
        this.setError(response.status);
        console.log('ERRO CHAMADA ==>',response)
      }
    }).catch((response) => {
      this.setError();
      console.log('ERRO CHAMADA ==>',response)
    });

    console.log('Fim processo Login')
  }

  getSalt(user, pass) {
    console.log('USER ==>',user)
    console.log('PASS ==>',pass)
    var v = Connection.ParseAddress(Connection.service + "Login/" +
      (this.state.mode == 1 ? "User" : "Employee")
      + "/" + encodeURIComponent(user));
    fetch(v).then((response) => {
      if (response.ok && response.status == 200)
        response.text().then((data) => {
          console.log('DATA ==>',data)
          this.getSession(user, data == null || data.length == 0 ? pass : String(sha1(data + pass)));
        }).catch(() => this.setError());
      else this.setError(response.status);
    }).catch((response) => {
      this.setError();
    });
  }

  newPassword(info) {
    this.setState({ modalLoading: true });
    var v = Connection.ParseAddress(Connection.service + "Login/Password/" + encodeURIComponent(info));
    fetch(v).then((response) => {
      if (response.ok && response.status == 200)
        this.setState({ isModalVisible: "success", modalLoading: false });
      else if (response.status == 204)
        this.setState({ isModalVisible: "notallowed", modalLoading: false });
      else
        this.setState({ isModalVisible: "error", modalLoading: false });
    }).catch((response) => {
      this.setState({ isModalVisible: "error", modalLoading: false });
    });
  }

  setError(code, msg) {
    console.log('ERROR ==>',code)
    this.setState({
      loading: false, error:
        code == 401 ? Labels.GetLabel("login.error401") :
          code == 402 ? Labels.GetLabel("login.error402") :
            code == 403 ? Labels.GetLabel("login.error403") :
              code == 404 ? Labels.GetLabel("login.error404") :
                code == 406 ? Labels.GetLabel("login.error406") :
                  Labels.GetLabel("login.error400")
    })
  }

  render() {
    return (
      <div className="login_panel" >{
        Labels.GetLabel("states.msg").length > 0 ?
          <div className="login_panel_msg">{Labels.GetLabel("states.msg")}</div> : null}
        <div style={{ flex: 1, display: "flex", position: "relative" }}>
          <div className="login_panel_left" style={{ backgroundImage: 'url(' + bkg + ')' }}>
            <div className="login_panel_left_version">{Labels.GetLabel("generic.version")}: {Labels.GetLabel("version.current")}</div>
          </div>
          <div className="login_panel_right">
            <div style={{ flex: 1, minWidth: 20 }}></div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
              <div className="login_panel_frame">
                <div className="login_panel_logo">
                  <img className="login_panel_logo_image" src={logo} alt="LONGPING HIGH-TECH" />
                </div>
                <div className="generics_panels_header"><FontAwesomeIcon icon={"user-lock"} /> <span>{Labels.GetLabel("login.header")}</span></div>
                <div>{
                  !this.state.loading ?
                    <Form.Group onSubmit={(t) => this.loginUser({ loading: true })}>
                      <MaskedInput type="email" icon="user" notnull={true} onValid={(value) => this.setState({ user: value })}
                        onInvalid={(value) => this.setState({ user: null })} />
                      <MaskedInput type="text" password={true} icon="key" notnull={true} onValid={(value) => this.setState({ password: value, })}
                        onInvalid={(value) => this.setState({ password: null })} />
                      <br />
                      <Button variant="success" type="submit" block onClick={() => this.loginUser()} disabled={this.state.password == null || this.state.user == null || (this.state.password.length < 3 && this.state.user.length < 3)}>
                        {Labels.GetLabel("login.btn")}</Button>
                      {this.state.error != null ?
                        <div style={{ color: "#da0000", marginTop: 20, borderRadius: 10, padding: 10, border: "1px solid #da0000" }}>{this.state.error}</div>
                        : null}
                      <div className="login_panel_language" onClick={() => {
                        Labels.toggleLanguage();
                        this.setState({ language: global.applanguage });
                      }}><FontAwesomeIcon icon="language" /> {this.state.language == "EN" ? "English" : "Português"}</div>

                      <div className="login_panel_reset_password" onClick={() => this.setState({ isModalVisible: "confirm" })}>{Labels.GetLabel("password.new")}</div>
                    </Form.Group>
                    : <div>
                      {Labels.GetLabel("login.loader")}
                    </div>}
                </div>
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 20 }}></div>
          </div>
        </div>
        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible != null}>
          {
            this.state.modalInitializing == true ?
              <div>
                {Labels.GetLabel("adminstategroup.saving")}
              </div>
              :
              this.state.isModalVisible == "confirm" ?
                <div>
                  <Modal.Header>
                    <Modal.Title>{Labels.GetLabel("password.new")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div style={{ padding: 20, backgroundColor: "#f4f4f4", fontSize: 20, border: "1px solid rgb(200,200,200)", marginBottom: 40 }}>
                      {Labels.GetLabel("password.request")}
                    </div>
                    <MaskedInput type="email" icon="envelope" autoComplete={false} notnull={true} label={Labels.GetLabel("generic.email")} onValid={(value) => this.setState({ email: value })}
                      onInvalid={(value) => this.setState({ email: null })} />
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                      {Labels.GetLabel("adminstategroup.closebtn")}
                    </Button>
                    <Button variant="primary" disabled={this.state.email == null} onClick={() => this.newPassword(this.state.email)}>
                      {Labels.GetLabel("generic.request")}
                    </Button>
                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                </div>
                :
                this.state.isModalVisible == "notallowed" ?
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel("password.new")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div style={{ padding: 20, backgroundColor: "#f4f4f4", fontSize: 20, border: "1px solid rgb(200,200,200)", marginBottom: 20 }}>
                        {Labels.GetLabel("password.notallowed")}
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="primary" onClick={() => this.setState({ isModalVisible: null })}>
                        {Labels.GetLabel("generic.confirm")}
                      </Button>
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div> :
                  this.state.isModalVisible == "success" ?
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel("password.new")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div style={{ padding: 20, backgroundColor: "#f4f4f4", fontSize: 20, border: "1px solid rgb(200,200,200)", marginBottom: 20 }}>
                          {Labels.GetLabel("password.success")}
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="primary" onClick={() => this.setState({ isModalVisible: null })}>
                          {Labels.GetLabel("generic.confirm")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div> :
                    this.state.isModalVisible == "error" ?
                      <div>
                        <Modal.Header>
                          <Modal.Title>{Labels.GetLabel("password.new")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div style={{ padding: 20, backgroundColor: "#f4f4f4", fontSize: 20, border: "1px solid rgb(200,200,200)", marginBottom: 20 }}>
                            {Labels.GetLabel("password.error")}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" onClick={() => this.setState({ isModalVisible: null })}>
                            {Labels.GetLabel("generic.confirm")}
                          </Button>
                        </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                      </div>
                      : null
          }
        </Modal>
      </div >
    );
  }

}